import { helpers } from '@vuelidate/validators'

export default maxValue =>
  helpers.withParams({ type: 'maxValueExclusive', max: maxValue }, value => {
    if (!helpers.req(value)) return true
    return value.constructor == Number && value < maxValue
  })
